import clsx from 'clsx'
import { KTSVG } from '../../../helpers'
import { HeaderUserMenu, ThemeModeSwitcher } from '../../../partials'
import { useLayout } from '../../core'
import { useAuth } from '../../../../app/modules/auth/core/AuthProvider'
import { useState } from 'react'
import { NotificationsMenu } from '../../../../app/modules/notifications/NotificationsMenu'
import { UserAvatar } from '../../../partials/layout/header-menus/UserAvatar'

const itemClass = 'ms-1 ms-lg-3'
const btnIconClass = 'svg-icon-1'
const btnClass =
  'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px w-md-40px h-md-40px'

const Navbar = () => {
  const { config } = useLayout()
  const { user } = useAuth()
  const [alarmStatus, setAlarmStatus] = useState<boolean>(false)
  let blinkSpanClass =
    'bullet bullet-dot bg-danger h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink'
  return (
    <div className='app-navbar flex-shrink-0'>
      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          className={clsx('position-relative', btnClass)}
        >
          <KTSVG path='/media/icons/duotune/general/gen007.svg' className={btnIconClass} />
          {alarmStatus == true && <span className={blinkSpanClass}></span>}
        </div>
        <NotificationsMenu setAlarmStatus={setAlarmStatus} />
      </div>
      <div className={clsx('app-navbar-item', itemClass)}>
        <ThemeModeSwitcher toggleBtnClass={clsx('btn-active-light-primary btn-custom')} />
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          className='cursor-pointer'
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          <UserAvatar user={user} size='sm' className='symbol-md-40px' />
        </div>
        <HeaderUserMenu />
      </div>

      {config.app?.header?.default?.menu?.display && (
        <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-color-primary w-35px h-35px'
            id='kt_app_header_menu_toggle'
          >
            <KTSVG path='/media/icons/duotune/text/txt001.svg' className={btnIconClass} />
          </div>
        </div>
      )}
    </div>
  )
}

export { Navbar }
